import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { DeleteLevelThreeApi, UpdateLevelThreeApi } from "./LevelThreeAction";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialSize from "material-table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewLevelThree = (props) => {
    useEffect(() => {
        props.setHeading("View Level Three");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    title="View Level Three"
                    columns={[
                        {
                            title: 'Level 1 Name', field: 'levelOneId.name', editable: 'never',
                            render: rowData => `${rowData.levelOneId.key} - ${rowData.levelOneId.name}`
                        },
                        {
                            title: 'Level 2 Name', field: 'levelOneId.name', editable: 'never',
                            render: rowData => `${rowData.levelTwoId.allKey} - ${rowData.levelTwoId.levelTwoName}`
                        },
                        { title: 'Level 3 Code', field: 'allLevlKey', editable: 'never', },
                        { title: 'Level 3 Name', field: 'levelThreeName' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/levelThree/?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data.sort((a, b) => a.levelOneId.key - b.levelOneId.key),
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "landscape";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Level Three Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                `${elt.levelOneId.key} - ${elt.levelOneId.name}`,
                                `${elt.levelTwoId.allKey} - ${elt.levelTwoId.levelTwoName}`,
                                elt.allLevlKey,
                                elt.levelThreeName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Level Three Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.UpdateLevelThreeApi(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteLevelThreeApi(oldData._id);
                                }, 600);
                            }),
                    }}
                    icons={{
                        Edit: (props) => <EditIcon {...props} style={{ color: "#1B91BF" }} />,
                        Delete: (props) => <DeleteOutlineIcon {...props} style={{ color: "#EC5C5C" }} />
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        DeleteLevelThreeApi: (levelFiveId) => dispatch(DeleteLevelThreeApi(levelFiveId)),
        UpdateLevelThreeApi: (newData, oldData) => dispatch(UpdateLevelThreeApi(newData, oldData)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingLevelThree: state.LevelThreeReducer.isFetchingLevelThree,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewLevelThree);